import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home_md_circle",
  "use": "icon-home_md_circle-usage",
  "viewBox": "0 0 46 45",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 46 45\" id=\"icon-home_md_circle\">\n    <ellipse fill=\"#FDF5DC\" rx=\"22.499\" ry=\"22.5\" transform=\"matrix(-1 0 0 1 22.51 22.5)\" />\n    <circle cx=\"22.505\" cy=\"22.501\" r=\"16.071\" fill=\"#E5F6F5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol